// extracted by extract-css-chunks-webpack-plugin
module.exports = {"terms":"app-components-subscribe-subscriptionterms--terms","termsLink":"app-components-subscribe-subscriptionterms--termsLink"};